import { useState } from "react";
import axios from "axios";
import { authenticate, isAuth, setFirebaseToken } from "../../auth/helpers";
import { ToastContainer, toast } from "react-toastify";

import { Paper, Grid, Box, Button, Typography } from '@mui/material';

import "react-toastify/dist/ReactToastify.min.css";
import { useDispatch } from "react-redux";
import { updateUser } from "../../reduxStore/entities/userDetails";
import signInStyle from "../../assets/jss/material-dashboard-react/components/signIn";
import resources from "../../core/Localization/Localization";
import image from "../../assets/img/bg7.jpg";
import HeaderSection from "./Sections/HeaderSection";
import { getSxStyle } from "../../utils/getSxStyle";
import { useNavigate } from "react-router-dom";


const Signin = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    //state hooks
    const [values, setValues] = useState({
        email: "",
        password: "",
        google_auth: "",
        buttonText: resources.form.confirm,
    });

    const { email, password, google_auth, buttonText } = values;

    const handleChange = (name) => (event) => {
        setValues({ ...values, [name]: event.target.value });
    };

    const getAuthRedirectUrl = () => {
        const CROSS_ENV = process.env.REACT_APP_BOOTSTRAP;

        if (['buyer', 'seller'].includes(CROSS_ENV)) {
            return "/home";
        }

        else {
            return "/admin/dashboard";
        };
    };

    const clickSubmit = (event) => {
        event.preventDefault();
        setValues({ ...values, buttonText: resources.form.confirming + "..." });
        axios({
            method: "POST",
            url: `${process.env.REACT_APP_API}/signin`,
            data: { email, password },
            headers: {
                "x-ignore-maintenance": true,
            },
        })
            .then((response) => {
                // save the response (user, token) localstorage/cookie
                authenticate(response);

                if (Notification.permission === 'granted') {
                    setFirebaseToken().then((token) => {
                        dispatch(updateUser({ firebase_token: token, userid: response.data.user.userid }));
                    });
                };

                setTimeout(() => {
                    setValues({ ...values, name: "", email: "", password: "", buttonText: resources.form.confirmed });
                    isAuth() ? navigate(getAuthRedirectUrl()) : navigate("/signin");
                }, 5000);
            })
            .catch((error) => {
                setValues({ ...values, buttonText: resources.form.confirm });
                console.log(error.response);
                toast.error(error.response?.data?.error);
            });
    };

    const signinForm = () => (
        <form
            onKeyDown={(e) => {
                if (e.key === "Enter") {
                    clickSubmit(e);
                }
            }}
        >
            <div className="form-group">
                <label className="text-muted">Email</label>
                <input onChange={handleChange("email")} value={email} type="email" className="form-control" />
            </div>

            <div className="form-group">
                <label className="text-muted">Password</label>
                <input onChange={handleChange("password")} value={password} type="password" className="form-control" />
            </div>
            <div className="form-group">
                <label className="text-muted">2FA</label>
                <input onChange={handleChange("google_auth")} value={google_auth} type="google_auth" className="form-control" />
            </div>

            <div>
                <Button variant="contained" color="primary" type="button" onClick={clickSubmit}>
                    {buttonText}
                </Button>
            </div>
        </form>
    );

    return (
        <>
            {/*<div className="col-md-6 offset-md-3">*/}
            {/*<Header*/}
            {/*    absolute*/}
            {/*    color="transparent"*/}
            {/*    brand="Smart Part d.o.o"*/}
            {/*    links={<HeaderLinks dropdownHoverColor="info" />}*/}
            {/*/>*/}
            <HeaderSection />

            <Box
                sx={(theme) => ({
                    ...getSxStyle(theme, signInStyle, ['pageHeader']),
                    ...{
                        backgroundImage: "url(" + image + ")",
                        backgroundSize: "cover",
                        backgroundPosition: "top center"
                    }
                })}
            >
                <Box sx={(theme) => getSxStyle(theme, signInStyle, ['mainWrapper'])}>

                    <Grid item xs={12} sm={12} md={3} xl={4}>
                        <Paper elevation={3}>
                            <Box sx={(theme) => getSxStyle(theme, signInStyle, ['formWrapper'])}>

                                <ToastContainer />
                                {/* {isAuth() ? <Redirect to="/admin/dashboard" /> : null} */}
                                <Typography variant="h4" align="center" sx={(theme) => getSxStyle(theme, signInStyle, ['title'])}>
                                    Smartpart Login
                                </Typography>

                                {signinForm()}
                                <br />
                            </Box>
                        </Paper>
                    </Grid>

                </Box>

            </Box>
            {/*</div>*/}
        </>
    );
};

export default Signin;
